import { Alert, Typography } from "antd";
import ReCAPTCHA from "react-google-recaptcha";

import type { RecaptchaChallengeController } from "@/hooks/useRecaptchaChallenge";
import { RECAPTCHA_MISSING_SITE_KEY_MESSAGE } from "@/constants";

const { Text } = Typography;

interface RecaptchaChallengeProps {
  controller: RecaptchaChallengeController;
  stepActions: readonly string[];
}

export const RecaptchaChallenge = ({
  controller,
  stepActions,
}: RecaptchaChallengeProps) => {
  const shouldRender =
    controller.isStepRequired(stepActions) ||
    (controller.activeAction !== null &&
      stepActions.includes(controller.activeAction));

  if (!shouldRender) {
    return null;
  }

  if (!controller.hasSiteKey) {
    return (
      <Alert
        className="recaptcha-challenge"
        message={RECAPTCHA_MISSING_SITE_KEY_MESSAGE}
        showIcon
        type="error"
      />
    );
  }

  return (
    <div className="recaptcha-challenge">
      <Text strong>Xác minh bảo mật</Text>
      <Text type="secondary">
        Hoàn tất reCAPTCHA trước khi tiếp tục thao tác đăng nhập.
      </Text>
      <div className="recaptcha-challenge__widget">
        <ReCAPTCHA
          key={controller.resetKey}
          onChange={controller.onTokenChange}
          onErrored={controller.onErrored}
          onExpired={controller.onExpired}
          sitekey={controller.siteKey}
        />
      </div>
    </div>
  );
};
